import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useMemo } from "react";

const ChecklistHeader = () => {
  const translate = useTranslate();
  const headers = useMemo(() => {
    return [
      {
        name: "engine",
        widthClasses: "min-w-[150px]",
      },
      {
        name: "lastUpdate",
        widthClasses: "min-w-[150px]",
      },
      {
        name: "tasks",
        widthClasses: "min-w-[150px]",
      },
      {
        name: "status",
        widthClasses: "min-w-[150px]",
      },
      {
        name: "",
        widthClasses: "",
      },
    ];
  }, []);

  return (
    <tr data-testid="test-checklist-header" className="font-[IberiaTextBold]">
      {headers.map((header, index) => (
        <th
          key={`th-${index}`}
          className={
            index === headers.length - 1
              ? `right-header ${header.widthClasses}`
              : `central-header ${header.widthClasses}`
          }
        >
          {translate(header.name)}
        </th>
      ))}
    </tr>
  );
};

export default ChecklistHeader;
